import React from 'react';
import {Box, Container, Grid, Paper, Typography} from '@mui/material';

interface OrganizationProps {
    icon: string;
    title: string;
    description: string;
    link: string;
    roundIcon?: boolean;
    size?: string;
}

const StudentOrganizations: React.FC = () => {
    const organizations: OrganizationProps[] = [
        {
            icon: "partners/vstup.png",
            title: "Вступ НаУКМА",
            description: "Допомагають абітурієнтам та розповідають про вступ до Могилянки",
            link: "https://vstup.ukma.edu.ua/student-organization?so-id=8",
            roundIcon: true,
            size: "65px"
        },
        {
            icon: "partners/dobrobyt.png",
            title: "Медична мережа «Добробут»",
            description: "Провідна медична мережа України. Партнер НаУКМА та медичного напряму KMA Winter School",
            link: "https://dobrobut.com/ua/about",
            roundIcon: false,
            size: "100px"
        },
        {
            icon: "partners/Sweeden.svg",
            title: "Україно-швейцарський проєкт «Розвиток медичної освіти»",
            description: "Міжнародний проєкт, що підсилює трансформацію медичної освіти в Україні. Партнер НаУКМА",
            link: "https://mededu.org.ua/purpose/",
            roundIcon: false,
            size: "100px"
        }
    ];

    return (
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 }, pt: {xs: 0, md: 8} }}>
            <Typography
                variant="h2"
                sx={{
                    fontSize: { xs: '2.5rem', md: '4rem' },
                    fontWeight: 700,
                    textAlign: 'center',
                    mb: { xs: 4, md: 6 },
                    fontFamily: 'Kyiv Type Serif'
                }}
            >
                Залучені студентські організації та партнери
            </Typography>

            <Grid
                container
                spacing={4}
                alignItems="stretch"
                justifyContent="center"
            >
                {organizations.map((item, index) => (
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Paper
                            elevation={0}
                            onClick={() => window.open(item.link, '_blank')}
                            sx={{
                                bgcolor: '#DEE8FF',
                                cursor: 'pointer',
                                p: { xs: 3, md: 3 },
                                flexGrow: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderRadius: '16px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    boxShadow: '0 6px 20px rgba(6, 33, 89, 0.15)',
                                    transform: 'translateY(-4px)'
                                }
                            }}
                        >
                            <Box
                                sx={{
                                    height: '90px',
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 1
                                }}
                            >
                                <Box
                                    component="img"
                                    src={item.icon}
                                    alt={`${item.title} icon`}
                                    sx={{
                                        width: item.size || '55px',
                                        height: item.size || '55px',
                                        borderRadius: item.roundIcon !== false ? '50%' : '0',
                                        objectFit: item.roundIcon !== false ? 'cover' : 'contain',
                                    }}
                                />
                            </Box>

                            <Box
                                sx={{
                                    minHeight: { xs: 'auto', md: '90px' },
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: { xs: 'flex-start', md: 'center' },
                                    justifyContent: 'center',
                                    mb: { xs: 2, md: 1.5 },
                                    px: 1
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        fontFamily: 'Kyiv Type Sans',
                                        fontSize: { xs: '1.25rem', md: '1.25rem' },
                                        textAlign: 'center',
                                        lineHeight: 1.3
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            </Box>

                            <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'flex-start' }}>
                                <Typography
                                    sx={{
                                        fontFamily: 'Kyiv Type Sans',
                                        fontSize: { xs: '0.95rem', md: '0.95rem' },
                                        textAlign: 'center',
                                        color: '#333',
                                        lineHeight: 1.5
                                    }}
                                >
                                    {item.description}
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default StudentOrganizations;